import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import AuthValidator from "../../auth/AuthValidator";
import EntriesTable from "./EntriesTable";
import CONSTANTS from "../../../misc/constants";
import FirebasePaginator from "../../utils/FirebasePaginator";
import { useFirebase } from "react-redux-firebase";

const AdminDashboard = () => {
  const firebase = useFirebase();

  useEffect(() => {
    document.title = `${CONSTANTS.APP_NAME} | Admin Dashboard`;
  }, []);

  return (
    <>
      <AuthValidator permission_level={5}>
        <h2>Admin Dashboard</h2>
        <h3>Entries</h3>
        <Link className="btn action-btn" to="/new-entry">
        <i className="fas fa-plus"></i>
        </Link>
        {/* <EntriesTable></EntriesTable> */}
        <FirebasePaginator
          ChildComponent={EntriesTable}
          reverse={true}
          firebaseQuery={firebase
            .ref("blog_entries")
            .orderByChild("meta/creationDate")}
          urlPath="/admin"
        />
      </AuthValidator>
    </>
  );
};

export default AdminDashboard;
